export const formatName = (name: string) => {
  if (!name) return ''

  const partesDoNome = name.split(' ')

  if (partesDoNome.length === 1) {
    return partesDoNome
  }

  if (partesDoNome.length === 2) {
    return partesDoNome[0] + ' ' + partesDoNome[1] + ' '
  }

  if (partesDoNome.length >= 3) {
    return (
      partesDoNome[0] +
      ' ' +
      partesDoNome[1] +
      ' ' +
      partesDoNome[2].charAt(0) +
      '.'
    )
  }
}
